import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot } from '@angular/router';

import { NavController } from '@ionic/angular';

import { Observable, map, withLatestFrom } from 'rxjs';

import { HestiaFhirResourcesService } from '@hestia/ngx-fhir';

import { DawbaRoutes } from '../route-constants';
import { DawbaAppService } from '../services/app.service';

@Injectable()
export class IntroCompletedRouteGuard implements CanActivateChild {
  constructor(private dawbaService: DawbaAppService, private navCtrl: NavController) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.dawbaService.isCarePlanLoaded$.pipe(
      withLatestFrom(this.dawbaService.carePlan$),
      map(([loaded, dawbaCarePlan]) => {
        console.log({ loaded, dawbaCarePlan });
        const completed = dawbaCarePlan.introActivity.status === 'completed';
        if (!completed) {
          this.navCtrl.navigateRoot(DawbaRoutes.IntroToIntroPage);
        }
        return completed;
      })
    );
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
}

@Injectable()
export class IntroNotCompletedRouteGuard implements CanActivateChild {
  constructor(private dawbaService: DawbaAppService, private navCtrl: NavController) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.dawbaService.isCarePlanLoaded$.pipe(
      withLatestFrom(this.dawbaService.carePlan$),
      map(([loaded, dawbaCarePlan]) => {
        console.log({ loaded, dawbaCarePlan });
        const completed = dawbaCarePlan.introActivity.status === 'completed';
        if (completed) {
          this.navCtrl.navigateRoot(DawbaRoutes.DashboardPage);
        }
        return !completed;
      })
    );
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
}

@Injectable()
export class FinishCompletedRouteGuard implements CanActivateChild {
  constructor(
    private dawbaService: DawbaAppService,
    private navCtrl: NavController,
    private fhirService: HestiaFhirResourcesService
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.dawbaService.isCarePlanLoaded$.pipe(
      withLatestFrom(this.dawbaService.carePlan$),
      map(([loaded, dawbaCarePlan]) => {
        console.log({ loaded, dawbaCarePlan });
        const completed = dawbaCarePlan.carePlanResource?.status === 'completed';

        const values = this.dawbaService.getDawbaActivityValues(dawbaCarePlan.finishActivity);

        if (values && (values['tfinish'] === '1' || values['pfinish'] === '1' || values['sfinish'] === '1')) {
          /*            if (!completed) {
              this.fhirService.patchResource({
          resourceType: 'CarePlan',
          resourceId: dawbaCarePlan.carePlanResource?.id,
          operations: [{ op: 'replace', path: '/status', value: 'completed' }]

        });
            }*/
          this.navCtrl.navigateRoot(DawbaRoutes.NoTaskAvailablePage);
        }

        return true;
      })
    );
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
